'use strict';

function getParentNodes(node, _parents) {
  _parents = _parents || [];
  var parent = node.parentNode;

  if (!parent) {
    return _parents;
  }

  _parents.push(parent); // end when match body


  if (parent === document.body) return _parents;
  return getParentNodes(parent, _parents);
}

function isOverflow(node) {
  if (!node) return '';
  var style;

  if (window.getComputedStyle) {
    try {
      style = window.getComputedStyle(node);
    } catch (e) {}
  } else if (node.currentStyle) {
    style = node.currentStyle;
  }

  if (!style) return '';
  return style["overflow"] || style["overflow-y"] || style["overflow-x"];
}

function isScrollElement(node) {
  return /(auto|scroll)/.test(isOverflow(node));
}

export default function (node, careHorizontal) {
  return getParentNodes(node).filter(function (parent) {
    return parent === document.body || isScrollElement(parent);
  });
}